module.exports = __webpack_public_path__ + "static/media/Jacco Vonk.08560481.jpg";